import { defineStore } from 'pinia';
import { reactive } from 'vue';

interface columnHeader {
    key: string,
    [key: string]: any,
}

export const usePositionsViewStore = defineStore('positionsView', () => {
    const columnsHeaders: {
        [key: string]: (context: any) => columnHeader[],
    } = reactive({});

    function setColumnsHeaders(type: string, newColumnsHeaders: (context: any) => columnHeader[]) {
        columnsHeaders[type] = newColumnsHeaders;
    }

    function getColumnsHeadersByType(type: string) {
        return columnsHeaders[type] || (() => []);
    }

    return {
        setColumnsHeaders,
        getColumnsHeadersByType,
    }
});
